import Typography from '@components/std-components/Typography'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { PRODUCT_OPERATIONS_LOADERS } from '@modules/order/stores/view/List/ListDataStore'
import { ListUIStore } from '@modules/order/stores/view/List/ListUIStore'
import classNames from 'classnames'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import * as css from './AverageWeekSales.css'
import QtyNumberInput from '../../components/QtyNumberInput'
import { getNumberFromLocale } from '@utils/get-number-form-locale'

const AverageWeekSales: FC<CellItem> = ({ rowData, column, cellData }) =>
  useObserver(function useHook() {
    const {
      uiStore: { isOrderEditable }
    } = useOrderContext()
    const viewContextVal = useViewContext()
    const { t } = useTranslation()
    if (!rowData) {
      return <FieldSkeleton />
    }
    const uiStore = viewContextVal.uiStore as ListUIStore
    const index = rowData?.id
      ? uiStore.dataStore.itemIndexObjectStore.getIndexByKey(rowData.id)
      : null
    const value = get(rowData, column.field) ?? 0
    const disabled = index
      ? uiStore.dataStore.itemIndexObjectStore.isObjectsDataLoading(
          index,
          index + 1,
          PRODUCT_OPERATIONS_LOADERS.UPDATING_CLIENT_ORDER_DRAFT_QUANTITY
        )
      : false
    const salesPeriod = get(rowData, 'summary.orderProduct.salesPeriod')
    const invalidValue = !salesPeriod?.NumberOfWeeks

    return (
      <div
        className={classNames(
          'flex justify-start column align-center',
          css['cell-container']
        )}
      >
        <QtyNumberInput
          id={rowData.id}
          isDecimal={true}
          onChange={e => {
            uiStore.updateSummaryDraftQuantity(
              rowData,
              // newProductQty = (newAWS * salesPeriodWeeks) / (salesQty/oldProductqty) // sellthrough
              Math.round(
                (getNumberFromLocale(e.target.value) *
                  (salesPeriod?.NumberOfWeeks || 0)) /
                  (get(rowData, 'summary.orderProduct.salesQuantity') /
                    get(rowData, 'summary.orderProduct.totalByProductQuantity') || 1) || 1
              )
            )
          }}
          value={Number(value || 0).toFixed(2)}
          disabled={disabled || invalidValue || !isOrderEditable}
        />
        {invalidValue && (
          <div>
            <Typography variant='caption2'>
              {t('order.salesPeriodEmptyMessage', 'No Sales Periods')}
            </Typography>
          </div>
        )}
      </div>
    )
  })

export default AverageWeekSales
